export default __webpack_public_path__ + "static/media/double-arrow-icon.e2b141f9.svg";